import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from './components/Home'
import Blog from './components/Blogs'
import Connect from './components/Connect'
import About from './components/About'


 function App() {
  return (
    <div>
       <Router>
    <div>
      <Route exact path="/" component={Home} />
      <Route exact path="/blogs" component={Blog} />
      <Route exact path="/connect" component={Connect} />
      <Route exact path="/about" component={About} />
    </div>
  </Router>
    </div>
  )
}

export default App;

